import { __rest } from 'tslib';
import React from 'react';
import { s as styled } from './styled-112a8bd0.js';

const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
const StyledInput = styled.input `
  width: 42.5px;
  height: 42.5px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-align: center;
  outline: none;
  margin-top: 40px;
  margin-bottom: 25px;
  &:focus {
    border: 1px solid #eb1f3a;
  }
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
const OptWrapper = styled.div `
  display: flex;
  justify-content: space-between;
`;
const SingleOtpInput = (_a) => {
    var { isFocus } = _a, rest = __rest(_a, ["isFocus"]);
    const ref = React.useRef();
    React.useEffect(() => {
        if (isFocus && ref.current) {
            ref.current.focus();
        }
    }, [isFocus]);
    return React.createElement(StyledInput, Object.assign({ type: "number" }, rest, { ref: ref }));
};
const OtpInput = ({ onChange, className, }) => {
    const [otp, setOtp] = React.useState(['', '', '', '', '', '']);
    const [currentFocus, setCurrentFocus] = React.useState(0);
    React.useEffect(() => {
        if (onChange)
            onChange(otp.join(''));
    }, [JSON.stringify(otp)]);
    return (React.createElement(OptWrapper, { className: className }, otp.map((item, index) => (React.createElement(SingleOtpInput, { key: index, value: otp[index], isFocus: currentFocus === index, onFocus: (e) => {
            setCurrentFocus(index);
            const temp = e.target.value;
            e.target.value = '';
            e.target.value = temp;
        }, onChange: (e) => {
            const length = e.target.value.length;
            const value = e.target.value.slice(length - 1, length);
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);
            if (index !== otp.length - 1)
                setCurrentFocus((prev) => prev + 1);
        }, onKeyDown: (e) => {
            const handleDelete = (e) => {
                e.preventDefault();
                const newOtp = [...otp];
                newOtp[index] = '';
                setOtp(newOtp);
            };
            switch (e.keyCode) {
                case BACKSPACE:
                    handleDelete(e);
                    setCurrentFocus((prev) => (prev !== 0 ? prev - 1 : prev));
                    break;
                case DELETE:
                    handleDelete(e);
                    break;
                case LEFT_ARROW:
                    setCurrentFocus((prev) => (prev !== 0 ? prev - 1 : prev));
                    break;
                case RIGHT_ARROW:
                    setCurrentFocus((prev) => prev !== otp.length - 1 ? prev + 1 : prev);
                    break;
            }
        } })))));
};

export { OtpInput as O };
